import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { View, StyleSheet } from "react-native";
import CustomText from "../components/common/general/CustomText/CustomText";
import CustomButton from "../components/common/general/CustomButton/CustomButton";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import { NavigationProp } from "@react-navigation/native";
import useResponsiveScreen from "../hooks/useResponsiveScreen";
import { MotiView } from "moti";
import ClassCardProgressListContainer from "../containers/school/ClassCardProgressListContainer/ClassCardProgressListContainer";
import { useAppConfig } from "../AppConfigProvider";
import { useNavigation } from "@react-navigation/native";
import DefaultLayout from "../layouts/DefaultLayout.web";
import { RootStackParamList } from "../navigation/AppNavigator.web";

function CustomSchoolFacultyCoursesView() {
  const posthog = usePostHog();
  const { isMedium } = useResponsiveScreen();
  const appConfig = useAppConfig();

  const navigation = useNavigation<NavigationProp<RootStackParamList>>();

  const integrationId = appConfig.axioSchools[0];

  const handleNavigateToStudentCourses = () => {
    navigation.navigate("Custom School Student Courses");
  };

  useEffect(() => {
    posthog?.capture("School Page Visited");
  }, []);

  return (
    <DefaultLayout pageHasChat={false}>
      <MotiView
        from={{
          opacity: 0,
          translateY: 20,
          scale: 1,
        }}
        animate={{
          opacity: 1,
          translateY: 0,
          scale: 1,
        }}
        delay={10}
        // @ts-expect-error - transition is not typed
        transition={{ type: "timing", duration: 500 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}>
          <View style={styles.titleRow}>
            <CustomText
              useTranslationText={false}
              text={"Courses"}
              size={isMedium ? "m" : "xs"}
              textType="display"
              weight="ultraBold"
              role="heading"
              aria-level="1"
            />
            <CustomText
              text="These are the courses that you are teaching as a faculty member."
              size="m"
              style={styles.coursesDescription}
            />
          </View>
          <CustomButton
            text="Go To Your Student Page"
            styleType="primaryLight"
            size="s"
            bold={true}
            onPress={() => handleNavigateToStudentCourses()}
          />
        </View>
      </MotiView>
      <CustomSpacing type="vertical" size="l" />
      <ClassCardProgressListContainer integrationId={integrationId} />
      <CustomSpacing type="vertical" size="l" />
    </DefaultLayout>
  );
}

const styles = StyleSheet.create({
  coursesDescription: {
    color: "#667085",
    marginTop: 8,
    marginBottom: 8,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: "Inter",
    fontWeight: 300,
    marginHorizontal: 4,
  },
  titleRow: { flexDirection: "column", flexWrap: "wrap", justifyContent: "flex-start" },
});

export default CustomSchoolFacultyCoursesView;
